import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	useChangeMyPasswordMutation,
	useLogoutMutation,
	useMyPasswordStatusQuery,
} from 'generated/graphql';
import { getAccessToken, setAccessToken } from '../../AccessToken';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { ForcePasswordChangeDialog } from '../AccountModule/ForcePasswordChangeDialog';
import { encryptMessage } from 'helpers/Crypto/JSEncrypt';

const AUTH_PATHS = [
	'/login',
	'/kitchen/login',
	'/printer-server/login',
	'/logout',
	'/signOut',
	'/forgot',
	'/forgot-password',
	'/authentication/404',
	'/qrinvoice',
	'/qr-invoice',
	'/buyer-info',
];

export const PasswordGate = ({ children }: { children: React.ReactNode }) => {
	const history = useHistory();
	const { pathname } = useLocation();
	const token = getAccessToken();
	const isAuthPath =
		AUTH_PATHS.some(path => pathname === path || pathname.startsWith(path + '/')) ||
		pathname.startsWith('/reset-password') ||
		pathname.startsWith('/user/');

	const { data, loading, error } = useMyPasswordStatusQuery({
		skip: !token || isAuthPath,
		fetchPolicy: 'network-only',
	});

	const [changeMyPassword, { loading: changing }] = useChangeMyPasswordMutation({
		onCompleted: result => {
			if (result?.changeMyPassword?.accessToken) {
				setAccessToken(result.changeMyPassword.accessToken);
				sessionStorage.setItem('key', result.changeMyPassword.accessToken);
			}
			localStorage.removeItem('rememberme');
			window.location.reload();
		},
	});

	const [logout] = useLogoutMutation();

	if (!token || isAuthPath || error) return <>{children}</>;
	if (loading) return <Loading />;
	if (!data?.myPasswordStatus?.mustChange) return <>{children}</>;

	return (
		<ForcePasswordChangeDialog
			open
			askCurrent
			reason={data.myPasswordStatus.reason}
			expiryDays={data.myPasswordStatus.expiryDays}
			historyCount={data.myPasswordStatus.historyCount}
			loading={changing}
			onLogout={() => {
				const user = JSON.parse(localStorage.getItem('loggedInUser') || 'null');
				logout({ variables: { ID: user?.ID } }).finally(() => {
					setAccessToken('');
					sessionStorage.removeItem('key');
					localStorage.removeItem('loggedInUser');
					history.push('/login');
				});
			}}
			onSubmit={({ currentPassword, newPassword }) => {
				changeMyPassword({
					variables: {
						currentPassword: encryptMessage(currentPassword || ''),
						newPassword: encryptMessage(newPassword),
					},
				});
			}}
		/>
	);
};
